"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _keyboardCommands = require("./keyboard-commands");

require("./modal.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * Note: Deprecate this modal. Use dialog/dialog.jsx instead. This implementation is not
 * very accessible.
 *
 * Modal is a full screen overlay that can be optionally dismissed by clicking esc or
 * click outside the modal contents IF onRequestClose is provided. Otherwise will
 * have to be programmatically removed from render via child interaction or other.
 */
var Modal = /*#__PURE__*/function (_React$Component) {
  _inherits(Modal, _React$Component);

  var _super = _createSuper(Modal);

  function Modal(props) {
    var _this;

    _classCallCheck(this, Modal);

    _this = _super.call(this, props);
    _this.handleClickOutside = _this.handleClickOutside.bind(_assertThisInitialized(_this));
    return _this;
  }
  /**
   * If this component can close itself automatically (onRequestClose supplied)
   * then accept clicks on the modal-overlay div as a request to close.
   */


  _createClass(Modal, [{
    key: "handleClickOutside",
    value: function handleClickOutside(evt) {
      var onRequestClose = this.props.onRequestClose;

      if (onRequestClose && evt.target.className === 'modal-overlay') {
        onRequestClose();
      }
    } // keyboard events for a11y are connected using keyboardCommands.

    /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */

    /* eslint-disable jsx-a11y/click-events-have-key-events */

  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "Modal ".concat(className)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "modal-overlay",
        onClick: this.handleClickOutside,
        role: "dialog"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "modal-content"
      }, children)));
    }
    /* eslint-enable jsx-a11y/no-noninteractive-element-interactions */

    /* eslint-enable jsx-a11y/click-events-have-key-events */

  }]);

  return Modal;
}(_react["default"].Component);

Modal.propTypes = {
  onRequestClose: _propTypes["default"].func,
  className: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired
};
Modal.defaultProps = {
  onRequestClose: function onRequestClose() {},
  className: ''
};

var _default = (0, _keyboardCommands.keyboardCommands)(Modal, [{
  keys: 'escape',
  connectCommand: function connectCommand(props) {
    if (props.onRequestClose) {
      props.onRequestClose();
    }
  }
}]);

exports["default"] = _default;